export default __webpack_public_path__ + "static/media/Bloodseer's Sash.5d99c7b3.jpg";